import * as React from "react";

export const RainbowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <linearGradient id="rainbowCTA" x1="0%" x2="100%" y1="0%" y2="0%">
        <stop offset="0%" stopColor="#FF5F6D" />
        <stop offset="35%" stopColor="#FFC371" />
        <stop offset="70%" stopColor="#4FACFE" />
        <stop offset="100%" stopColor="#00F2FE" />
      </linearGradient>
    </defs>
    <path
      d="M6 18c0-4.418 3.582-8 8-8s8 3.582 8 8h4c0-6.627-5.373-12-12-12S2 11.373 2 18h4Zm4 0a4 4 0 0 1 8 0h4c0-4.418-3.582-8-8-8s-8 3.582-8 8h4Zm4 0a1 1 0 0 1 2 0h4c0-3.314-2.686-6-6-6s-6 2.686-6 6h4Z"
      fill="url(#rainbowCTA)"
    />
  </svg>
);
